/* eslint-env jest */
import { selectableDesigns, defaultPoseFor, readyToDecide } from './freeItemPage';
import { ORIENTATION } from '../../../hooks/useImageOrientation';

// The free-item picker's decisions (#5747): which designs this child can be
// put on, which photo to start on, and when the page may decide.
const png1 = { id: 1, extension: '.png', watermarkUrl: 'a-01.png' };
const png2 = { id: 2, extension: '.png', watermarkUrl: 'a-02.png' };
const jpg = { id: 3, extension: '.jpg', watermarkUrl: 'a-03.jpg' };
const cutout = {
  id: 160, name: 'Weekly Dry Erase Magnet - School', allowsJpgPoses: false, allowsLandscapePoses: false,
};
const framed = {
  id: 124, name: '2027 Calendar Magnet', allowsJpgPoses: null, allowsLandscapePoses: null,
};

describe('selectableDesigns', () => {
  it('keeps only the photos each design can hold, through the ONE eligibility rule', () => {
    const designs = selectableDesigns([cutout, framed], [png1, jpg]);
    expect(designs.map((d) => d.addon.id)).toEqual([160, 124]);
    expect(designs[0].poses).toEqual([png1]);
    expect(designs[1].poses).toEqual([png1, jpg]);
  });

  it('drops a design this child has NO usable photo for -- never re-offers the refused ones', () => {
    expect(selectableDesigns([cutout], [jpg])).toEqual([]);
    expect(selectableDesigns([cutout, framed], [jpg]).map((d) => d.addon.id)).toEqual([124]);
  });

  it('drops a landscape photo from an upright-only design once measured', () => {
    const orientations = { 'a-02.png': { orientation: ORIENTATION.LANDSCAPE } };
    expect(selectableDesigns([cutout], [png1, png2], orientations)[0].poses).toEqual([png1]);
  });

  it('is empty with no set or no photos', () => {
    expect(selectableDesigns([], [png1])).toEqual([]);
    expect(selectableDesigns([cutout], [])).toEqual([]);
    expect(selectableDesigns(undefined, undefined)).toEqual([]);
  });
});

describe('defaultPoseFor', () => {
  const design = { addon: cutout, poses: [png1, png2] };

  it('starts on the favourite when the design can hold it, else the first usable photo', () => {
    expect(defaultPoseFor(design, 2)).toBe(png2);
    expect(defaultPoseFor(design, '2')).toBe(png2);
    expect(defaultPoseFor(design, 3)).toBe(png1);
    expect(defaultPoseFor(design, undefined)).toBe(png1);
    expect(defaultPoseFor(null, 1)).toBeNull();
  });
});

describe('readyToDecide', () => {
  const settled = {
    loadingPackage: false, packageId: 877, loadingOffer: false, loadingCart: false, poses: [png1], posesPlaceholder: false,
  };

  it('is ready on settled queries with real pose data, and on genuinely empty real data', () => {
    expect(readyToDecide(settled)).toBe(true);
    expect(readyToDecide({ ...settled, poses: [] })).toBe(true);
  });

  it('is NOT ready on placeholders, before the package resolves, or while anything loads', () => {
    expect(readyToDecide({ ...settled, posesPlaceholder: true })).toBe(false);
    expect(readyToDecide({ ...settled, backgroundsPlaceholder: true })).toBe(false);
    expect(readyToDecide({ ...settled, packageId: undefined })).toBe(false);
    expect(readyToDecide({ ...settled, loadingCart: true })).toBe(false);
    expect(readyToDecide({ ...settled, poses: undefined })).toBe(false);
  });
});
